 // Footer.js
import React from "react";
import {
  Box,
  Container,
  Grid,
  Link,
  linkClasses,
  Typography,
} from "@mui/material";
import Logo from "../public/Logo.png";
import { useNavigate } from "react-router-dom";
import Facebook from "../public/facbookLOGO.png";
import MailLogo from "../public/mailLogo.png";


const Footer = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{ backgroundColor: "#050324", color: "#fff", padding:{md:"20px 0",sm:"20px 27px" , xs:"20px 27px"}, mt: 5 }}
    >
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Box>
                 <Box sx={{padding:1}}>
                 <Typography variant="h3" color="#d9d9d9"  sx={{fontSize:"2.5rem", textDecoration:"#015c0e underline", marginLeft:"5.5rem"}}>
                  Elite Engineering
                </Typography>
                <Box
                sx={{ bgcolor: "#fff", width: 40, borderRadius: 10, mt: -5 }}
                >
                <img src={Logo} style={{ width: 40 }} alt="Logo" />
                </Box>
                 </Box>
                <Typography sx={{ fontSize: "1.5rem" }}>
                  Elite Engineering established in 01 June 2006 is a leading
                  company , providing complete turnkey solution to industries.
                </Typography>
              </Box>
               
            </Box>
            <Link
              href="https://www.facebook.com/elitekorba/"
              color="inherit"
              target="_blank" 
              rel="noopener noreferrer" 
              sx={{ display: "inline-block", marginTop: "10px" }}
            >
              <Box
                sx={{ bgcolor: "#fff", borderRadius: "50%", cursor: "pointer" }}
              >
                <img
                  src={Facebook}
                  style={{ width: 40, height: 40 }}
                  alt="FB-LOGO"
                />
              </Box>
            </Link>
            <Link
              href="mailto:elite22.krb@gmail.com"
              color="inherit"
              sx={{ display: "inline-block", marginTop: "10px" }}
            >
              <Box
                sx={{
                  bgcolor: "#fff",
                  borderRadius: "50%",
                  cursor: "pointer",
                  ml: 2,
                  mr: 2,
                   
                }}
              >
                <img
                   
                  src={MailLogo}
                  style={{ width: 40, height: 40, borderRadius: "50%" }}
                  alt="FB-LOGO"
                />
              </Box>
            </Link>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h3" color="#fff"  sx={{fontSize:"2.5rem", textDecoration:"#015c0e underline"}}>
              Quick Link
            </Typography>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {pages.map((item) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    height: "auto",
                  }}
                >
                  <Typography
                    variant="h4"
                    mt={2}
                    sx={{ color: "#fff", cursor: "pointer", fontSize:"1.5rem" }}
                    onClick={() => navigate(item?.link)}
                  >
                    {item?.name}
                  </Typography>
                </Box>
              ))}
            </ul>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h3" color="#fff"  sx={{fontSize:"2.5rem", textDecoration:"#015c0e underline"}}>
              Contact Us
            </Typography>
            <Typography variant="body2">
              <Link
                href="mailto:officebbsr@papl.tech"
                fontSize={"14px"}
                color="inherit"
              >
                elite22.krb@gmail.com
              </Link>
            </Typography>
            <Typography
              variant="h3"
              sx={{ color: "#fff", marginTop: "20px", mb: 2 , fontSize:"1.5rem", cursor:"pointer"}}
              onClick={() => navigate("/portfolio")}
            >
              Gallery
            </Typography>
            <Grid container spacing={1}>
              {[
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGYWqcM-hsz9G7Bj7kCHcZvBqF_TDGTFQUxA&s",
                "https://www.pollisum.com/wp-content/uploads/2024/05/unnamed-33.png",
                "https://indiacsr.in/wp-content/uploads/2021/09/balco-smelter.jpeg",
                "https://d3u7ubx0okog7j.cloudfront.net/images/mineareaCIL.original.png",
              ].map((src, index) => (
                <Grid item xs={4} key={index}>
                  <img
                    src={src}
                    alt={`Gallery ${index + 1}`}
                    style={{ width: "80%", height: 80 }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        {/* <Typography variant="body2" align="center" sx={{ marginTop: '20px' }}>
          Copyright © 2023. All rights reserved. Design by <Link href="https://kytics.com" color="inherit">kytics</Link>.
        </Typography> */}
      </Container>
    </Box>
  );
};

export default Footer;

const pages = [
  { name: "Home", link: "/" },
  { name: "About", link: "/about" },
  { name: "Our Services", link: "/services" },
  { name: "Portfolio", link: "/portfolio" },
  { name: "Contact", link: "/contact-us" },
  //   { name: "Career", link: "#" },
  //   { name: "Privacy Policy", link: "#" },
  //   { name: "Terms & Conditions", link: "#" },
];
